import {
  JOURNEY_STATUS,
  JOURNEY_STATUS_COLOR_CONFIG,
} from "../utils/constants";

interface JourneyStatusPillProps {
  status: string;
}

const JourneyStatusPill = ({ status }: JourneyStatusPillProps) => {
  const config =
    JOURNEY_STATUS_COLOR_CONFIG[status?.toLowerCase() as JOURNEY_STATUS];

  if (!config) return null;

  const Icon = config.Icon;
  return (
    <div
      className={`px-2 py-0.5 max-w-fit rounded-md flex items-center gap-1 border ${config.className} shadow-xs-blur`}
    >
      {Icon && <Icon className="w-3 h-3 shrink-0" />}
      <span className={`text-sm font-medium capitalize`}>{status}</span>
    </div>
  );
};

export default JourneyStatusPill;
